import { ListsDashboardSourceEnum } from '@/bundles/App/enums';
import { DashboardViewEnum } from '@/bundles/DashboardAnalytics/types';
import {
  IListsDashboardsState,
  IPipelineDashboardSlice,
  IPipelineDashboardFilters,
  PipelineMeasureEnum,
  PipelineKanbanSortEnum,
} from '@/bundles/Pipeline/types';
import {
  IDealsDashboardFilters,
  IDealsDashboardSlice,
  DealsMeasureEnum,
} from '@/bundles/Deals/types';
import {
  IAvailabilitiesDashboardSlice,
  IAvailabilitiesDashboardFilters,
  AvailabilitiesDistributionSortEnum,
} from '@/bundles/Availabilities/types';
import {
  IComparablesDashboardSlice,
  IComparablesDashboardFilters,
  ComparableDashboardWindowEnum,
} from '@/bundles/Comparables/types';
import { DEFAULT_PAYMENT_STATUS } from '@/bundles/Deals/helpers/dealsFiltersQuery';
import { getThreeYearForecastRange } from '@/bundles/Pipeline/helpers/dashboard/pipelineFiltersQuery';

export const getDefaultPipelineFilters = (): IPipelineDashboardFilters => ({
  year: getThreeYearForecastRange(),
  businessLine: null,
  propertyType: [],
  source: [],
  transactionCategory: [],
  representationSide: [],
  broker: [],
  allBrokers: false,
  stages: [],
  setId: null,
});

export const getDefaultPipelineSlice = (): IPipelineDashboardSlice => ({
  filters: getDefaultPipelineFilters(),
  filterOptions: {
    data: null,
    loading: false,
    error: null,
  },
  activeMeasure: PipelineMeasureEnum.agentGross,
  kanbanSort: PipelineKanbanSortEnum.consideration,
  view: DashboardViewEnum.analyze,
});

export const getDefaultDealsFilters = (): IDealsDashboardFilters => ({
  year: [new Date().getFullYear()],
  businessLine: null,
  propertyType: [],
  source: [],
  transactionCategory: [],
  representationSide: [],
  paymentStatus: [...DEFAULT_PAYMENT_STATUS],
  agentGroup: [],
  broker: [],
  allBrokers: false,
  setId: null,
});

export const getDefaultDealsSlice = (): IDealsDashboardSlice => ({
  filters: getDefaultDealsFilters(),
  filterOptions: {
    data: null,
    loading: false,
    error: null,
  },
  activeMeasure: DealsMeasureEnum.consideration,
  view: DashboardViewEnum.analyze,
});

export const getDefaultAvailabilitiesFilters = (): IAvailabilitiesDashboardFilters => ({
  transactionType: [],
  propertyType: [],
  primaryUse: [],
  useType: [],
  spaceRange: [],
  constructionStatus: [],
  listingCompany: [],
  listingAgent: [],
  trueOwner: [],
  setId: null,
});

export const getDefaultAvailabilitiesSlice = (): IAvailabilitiesDashboardSlice => ({
  distributionSort: AvailabilitiesDistributionSortEnum.sf,
  filters: getDefaultAvailabilitiesFilters(),
});

export const getDefaultComparablesFilters = (): IComparablesDashboardFilters => ({
  propertyType: [],
  transactionType: [],
  dealSize: [],
  leaseType: [],
  submarket: [],
  submarketCluster: [],
  leaseExpiration: [],
  yearBuiltBand: [],
  source: [],
  dealTypes: [],
  leaseTypes: [],
  saleSubtypeMode: 'all',
  window: ComparableDashboardWindowEnum.last_12_months,
  periods: [],
  comparedSubmarkets: [],
  comparedSubmarketClusters: [],
  setId: null,
});

export const getDefaultComparablesSlice = (): IComparablesDashboardSlice => ({
  filters: getDefaultComparablesFilters(),
  ui: {
    sortMetric: 'sf',
    agentSide: 'buyer',
    brokerageSide: 'buyer',
    partySide: 'buyer',
    agentCompare: false,
    brokerageCompare: false,
    partyCompare: false,
    combineBrokerageParentChild: true,
    combinePartyParentChild: true,
  },
});

export const SLICE_FACTORIES: { [K in ListsDashboardSourceEnum]: () => IListsDashboardsState[K] } = {
  [ListsDashboardSourceEnum.pipeline]: getDefaultPipelineSlice,
  [ListsDashboardSourceEnum.deals]: getDefaultDealsSlice,
  [ListsDashboardSourceEnum.availabilities]: getDefaultAvailabilitiesSlice,
  [ListsDashboardSourceEnum.comparables]: getDefaultComparablesSlice,
};
